<script lang="ts" setup>
  
  // nyelvi es routing beallitasok
  const localePath = useLocalePath();

</script>

<template>
  <div class="bg-boxbg-dark shadow-lg rounded-md">
    <img
      src="/shop/top_00.jpg"
      class="rounded-t-md"
      alt="Bestsellers"
      title="Bestsellers"
    />
    <div class="p-4 mx-2 mb-5">
      <p class="font-bold mb-2">
        <span class="text-navbg-dark text-lg">
          <font-awesome-icon :icon="['fas', 'at']"
        /></span>
        {{ $t('Would you contact us') }}?
      </p>
      <div class="flex flex-wrap gap-1">
        <NuxtLink :to="localePath('contact-us')" class="block flex-auto"
          ><UiButton class="w-full text-txt-dark"
            >{{ $t('Contact us ') }}..</UiButton
          ></NuxtLink
        >
        <NuxtLink :to="localePath('contact-us')" class="block flex-auto"
          ><UiButton class="w-full text-txt-dark"
            >{{ $t('Business hours') }}..</UiButton
          ></NuxtLink
        >
      </div>
    </div>
  </div>
</template>
